/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const newsYearList = () => {
		if($('.js-news-yearList').length) {
			var latest = $('.js-news-latest-year').text();
			var earliest = $('.js-news-earliest-year').text();
			const pagePath = location.pathname;
			let newsVal;
			let nameAll = '最新20件';
			
			let pathHead = '';
			let category = '';
			if (pagePath.indexOf('/ja/news/') != -1) {
				pathHead = '/ja/news/';
				category = pagePath.split('/')[4];
			}else if (pagePath.indexOf('/ja/product/news/') != -1) {
				pathHead = '/ja/product/news/';
				category = pagePath.split('/')[5];
			}else if (pagePath.indexOf('/ja/technology/technical_review/') != -1) {
				pathHead = '/ja/technology/technical_review/';
				category = pagePath.split('/')[5];
			}else if (pagePath.indexOf('/ja/ir/irnews/') != -1) {
				pathHead = '/ja/ir/irnews/';
				category = pagePath.split('/')[5];
			}
			
			const optionVal = (_num) => {
				if(category === '') {
					return pathHead+_num+'/';
				} else {
					return pathHead+_num+'/'+category+'/';
				}
			};

			if(category === '') {
				newsVal = pathHead + 'latest/';
			} else {
				newsVal = pathHead + 'latest/' +category+'/';
			}

			// optionを追加
			$('.js-news-yearList').append($('<option>').html(nameAll).val(newsVal));
			for(var i =latest; i>=earliest; i--) {
				$('.js-news-yearList').append($('<option>').html(''+i+'').val(optionVal(i)));
			}

			// 見ている年をselected
			$('.js-news-yearList').val(location.pathname);
			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				if(!($( 'input[name=p_business]' ).length)) {
					location.href = $(this).val();
				} else {
					const form = $('.js-product-news-form');
					form.attr('action', $(this).val());
					$('input[name=category]' ).removeAttr('name');
					form.submit();
				}
			});
		}
	};
	const newsCurrent = () => {
		$( 'input[name=category]' ).val([location.pathname]);
		$( 'input[name=category]:radio' ).change( function() {
			location.href = $(this).val();
			if(!($( 'input[name=p_business]' ).length)) {
				location.href = $(this).val();
			} else {
				const form = $('.js-product-news-form');
				form.attr('action', $(this).val());
				$('input[name=category]' ).removeAttr('name');
				form.submit();
			}
		})
	};
	const newsBusiness = () => {
		//"?p_business="が出てしまし、すべてが選択されないので追加。"?p_business="がでなくなれば削除
		const parameter = location.search.slice(1);
		if (parameter !== "") {
			let parameterTempList = new Array();	
			if (parameter.indexOf('&') != -1) {
				parameterTempList = $.merge (parameterTempList,parameter.split('&'));
			}else {
				parameterTempList.push(parameter);
			}	
			let parameterList = new Object();
			for (let i = 0; i < parameterTempList.length; i++) {
				const parameterTempData = parameterTempList[i].split('=');
				parameterList[parameterTempData[0]] = parameterTempData[1] ;
			}
			$( 'input[name=p_business]' ).val([parameterList.p_business]);
		} else {
			$( 'input[name=p_business]' ).val(['']);
		}
		//"?p_business="が出てしまし、すべてが選択されないので追加。"?p_business="がでなくなれば削除
		
		$( 'input[name=p_business]:radio' ).change( function() {
			const form = $('.js-product-news-form');
			form.attr('action', location.pathname);
			$('input[name=category]' ).removeAttr('name');
			form.submit();
		})
	}
	newsYearList();
	newsCurrent();
	newsBusiness();
})(window.jQuery, window.FUNCTIONS);